export const ATTRIBUTE_MAP: {
  [key in T.Schema.Restaurant.Promo.PromoType]: keyof T.Schema.Restaurant.RestaurantSchema;
} = {
  discount: 'promos',
  free_item: 'free_item_promos',
};
